import { useContext } from "react";

import { type CreateToasterReturn } from "@chakra-ui/react";

import { ToastContext } from "./toast-provider";

export const useToaster = (): CreateToasterReturn => {
  const context = useContext(ToastContext);

  if (context === undefined) {
    throw new Error("useToaster must be used within a ToastProvider");
  }

  return context.toaster;
};
